import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { CodaltComponent } from '../codalt.component';
import { AuthService } from '../services/auth/auth.service';
import { User } from '../user.interface';

@Component({
    selector: 'app-take-over',
    templateUrl: './take-over.component.html',
    standalone: false,
})
export class TakeOverComponent extends CodaltComponent implements OnInit {
    errorMessage: string | null = null;

    constructor(
        private route: ActivatedRoute,
        private router: Router,
        private authService: AuthService
    ) {
        super();
    }

    ngOnInit() {
        const params = this.route.snapshot.queryParamMap;
        const token = params.get('token');

        if (!token) {
            this.router.navigate([this.Routenames.login], { replaceUrl: true });
            return;
        }

        const parentToken = params.get('parentToken');
        const parentUserId = params.get('parentUserId');
        const parentUserName = params.get('parentUserName');
        const crossAppParent =
            parentToken && parentUserId && parentUserName
                ? { token: parentToken, user: { id: +parentUserId, name: parentUserName } as User }
                : undefined;

        this.subscriptions.add(
            this.authService.switchToProfile(token, crossAppParent).subscribe({
                next: () => this.router.navigate(['/'], { replaceUrl: true }),
                error: error => (this.errorMessage = error.message),
            })
        );
    }
}
